export interface ProductDetail {
    ProductID: number;
    Field: string;
    IsLocked?: boolean;
    OldValue: string;
    NewValue: string;
}
